import { useAuth } from "../context/Auth/AuthContext";

const featureFlags = {
	expertHelp: false,
	oneClickApply: false,
	dsp: true,
	companyClaim: false,
};

export const supportedJobs = ["684b8f9d2dcc2c09c71b092d", "686366962dcc2c09c71b0936", "686366962dcc2c09c71b0937"];

export function useFeatureFlag(flagName) {
	const { userData } = useAuth();
	const requiresOpsAccess = flagName === "featureToggle" || flagName === "posterGenerator";
	const isEnabled = requiresOpsAccess ? Boolean(userData?.isDropzOpsUser) : Boolean(featureFlags[flagName]);

	// In development, always enable features for testing
	return import.meta.env.DEV ? true : isEnabled;
}
